// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BoundedAxis } from "./BoundedAxis";
import {
  BoundedAxisFromJSON,
  BoundedAxisFromJSONTyped,
  BoundedAxisToJSON,
  BoundedAxisToJSONTyped,
} from "./BoundedAxis";

/**
 *
 * @export
 * @interface BoundedGridWithOptionalAxes
 */
export interface BoundedGridWithOptionalAxes {
  /**
   *
   */
  x?: BoundedAxis | null;
  /**
   *
   */
  y?: BoundedAxis | null;
  /**
   *
   */
  crs: string;
}

/**
 * Check if a given object implements the BoundedGridWithOptionalAxes interface.
 */
export function instanceOfBoundedGridWithOptionalAxes(
  value: object
): value is BoundedGridWithOptionalAxes {
  if (!("crs" in value) || value["crs"] === undefined) return false;
  return true;
}

export function BoundedGridWithOptionalAxesFromJSON(json: any): BoundedGridWithOptionalAxes {
  return BoundedGridWithOptionalAxesFromJSONTyped(json, false);
}

export function BoundedGridWithOptionalAxesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BoundedGridWithOptionalAxes {
  if (json == null) {
    return json;
  }
  return {
    x:
      json["x"] === undefined
        ? undefined
        : json["x"] === null
        ? null
        : BoundedAxisFromJSON(json["x"]),
    y:
      json["y"] === undefined
        ? undefined
        : json["y"] === null
        ? null
        : BoundedAxisFromJSON(json["y"]),
    crs: json["crs"],
  };
}

export function BoundedGridWithOptionalAxesToJSON(json: any): BoundedGridWithOptionalAxes {
  return BoundedGridWithOptionalAxesToJSONTyped(json, false);
}

export function BoundedGridWithOptionalAxesToJSONTyped(
  value?: BoundedGridWithOptionalAxes | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    x: BoundedAxisToJSON(value["x"]),
    y: BoundedAxisToJSON(value["y"]),
    crs: value["crs"],
  };
}
